module.exports = __webpack_public_path__ + "static/carlsbad-8-70b9276d89694fac2440e5488680d03d.jpeg";